import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { isVisible } from "@grindex-common/helpers/domManipulation";

const SITE_HEADER = ".component-header";
const SELECTOR_TAB = ".tab-content";
const SELECTOR_NON_SLIDERS = ".cardSlider:not(.is-slider)";
const SELECTOR_GRAY_AREA_SLIDERS = ".gray-content-area .cardSlider";
const SELECTOR_LI_SECTIONS = "li section";
const SLIDER_CLASS = "is-slider";

export default class productSeriesDom extends DomElementsBase {
	constructor($module) {
		const selectors = [SITE_HEADER, SELECTOR_GRAY_AREA_SLIDERS, SELECTOR_LI_SECTIONS, SELECTOR_NON_SLIDERS, SELECTOR_TAB];

		super($module, selectors);

		this.elements = {
			siteHeaderElement: function () {
				return this.getElement(SITE_HEADER);
			},

			visibleTabElement: () => {
				return [...this.getElements(SELECTOR_TAB)].filter(($tab) => {
					return isVisible($tab);
				})[0];
			},

			nonSliderElements: function () {
				return this.getElements(SELECTOR_NON_SLIDERS);
			},

			grayAreaSliderElements: function () {
				return this.getElements(SELECTOR_GRAY_AREA_SLIDERS);
			},

			liSectionElements: function () {
				return this.getElements(SELECTOR_LI_SECTIONS);
			},

			unInitializedTabSliders: function () {
				return this.visibleTabElement().querySelectorAll(SELECTOR_NON_SLIDERS);
			},
		};
	}

	addSliderClass($slider) {
		$slider.classList.add(SLIDER_CLASS);

		return $slider;
	}
}
